<template>
  <div style="display: flex;align-items: center;justify-content: center">
    <van-button @click="callback" type="primary" :disabled="disabled" :style="{
          margin:margin??'38px 0 10px 0',
          backgroundColor:hcf.getMainColor(),
          height:'50px',
          width:width??defaultWidth,
          fontSize:'15px',
          borderRadius:'30px',
        }">{{title}}
    </van-button>
  </div>
</template>


<script setup>
  import {hcf} from "@/components/utils/HComFunctions.js";

  defineProps(["callback","title","width","disabled","margin"]);
  const defaultWidth = ref(0);
  onMounted(()=>{
    defaultWidth.value = window.innerWidth*0.8+'px';
  });
</script>


<style scoped>
  ::v-deep(.van-button--primary){
    border:var(--van-button-border-width) solid var(--ct-main-color);
  }
</style>
